<template>
<div>
  <div class="row justify-content-center">
                      <div class=" col-sm-12 grid-margin stretch-card">

                        <div class="card">
                          <div class="card-tile text-center p-2"><h2 class="">Users</h2></div>
                          <div class="card-body text-center">
                            <div class="mb-3 row justify-content-center">
                              <div class="col-sm-6 float-right">
                              <input type="text" v-model="message.filterval"  v-on:keyup="filter()" class="form-control" placeholder="Type to start filtering">
                              </div>
                            </div>
                            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="text-center">
                      <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">First Name</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Last Name</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Email</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Phone</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Role</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">User Type</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Status</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Created</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Action</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data,index) in users" :key="data.id" class="text-center">
                      <td>
                        {{index+1}}
                      </td>
                      <td>
                        {{data.fname}}
                      </td>
                      <td >
                        {{data.lname}}
                      </td>
                      <td >
                        {{data.email}}
                      </td>
                      <td >
                        {{data.phone}}
                      </td>
                       <td >
                        {{data.role}}
                      </td>
                      <td >
                        {{data.user_type}}
                      </td>
                      <td v-if="data.status==='ACTIVE'" class="text-success">
                        {{data.status}}
                      </td>
                      <td v-else  class="text-danger">
                        {{data.status}}
                      </td>
                      <td >
                       {{filerDate(data.updated_at)}}
                      </td>
                      <td>
                        <a href="#" v-on:click="ShowModal(data.fname,data.lname,data.email,data.phone,data.id,data.status)" class=" text-success"><i class="mdi mdi-pencil text-success"></i></a>
                      </td>

                    </tr>

                  </tbody>
                </table>
              </div>
              <div class="row mt-4 justify-content-center">
                    <div class="col-sm-12">
                        <jw-pagination :items="users"  @changePage="onChangePage" ></jw-pagination>
                    </div>
                </div>

                          </div>
                        </div>




                        </div>
                        </div>

 <div class="modal fade" id="edit" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body p-5">
         <h6 class="text-center">Update user details</h6>
         <div class="form-group mt-3">
                    <label class="form-label">First Name</label>
                    <input type="text" v-model="message.fname" class="form-control" required>
                  </div>
                    <div class="form-group mt-3">
                    <label class="form-label">Last Name</label>
                    <input type="text" v-model="message.lname" class="form-control" required>
                  </div>
                    <div class="form-group mt-3">
                    <label class="form-label">Email</label>
                    <input type="email" v-model="message.email" class="form-control" required>
                  </div>
                  <div class="form-group mt-3">
                    <label class="form-label">Phone</label>
                    <input type="number" v-model="message.phone" class="form-control" required>
                  </div>
                  <div class="form-group mt-3 ">
                    <label class="form-label">Status <span class="text-danger">*</span></label>
                    <select class="form-control form-select"  v-model="message.status">
                    <option selected disabled>Select status</option>
                     <option >ACTIVE</option>
                     <option >INACTIVE</option>
                    </select>
                  </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" v-on:click="updateUser()">Save changes</button>
      </div>
    </div>
  </div>
</div>
</div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'App',
        components: {

        },
        data(){
            return {
            users:[],
             users2:[],
            message:{id:'',lname:'',fname:'',email:'',phone:'',status:''},
             pageOfItems:[],

            }
        },
        created(){
              this.Users();
        },
        methods: {
          ShowModal(fname,lname,email,phone,id,status){
            this.message.email=email;
            this.message.id=id;
            this.message.fname=fname
            this.message.lname=lname
            this.message.phone=phone
            this.message.status=status;
             $('#edit').modal('show');
          },
          onChangePage(pageOfItems) {
            this.pageOfItems = pageOfItems;
        },
          updateUser(){
            $('#edit').modal('hide');
             this.$loading(true)
               let uri =`/api/auth/updateUser`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                   this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                   this.Users();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },
            Users(){

                let uri =`/api/auth/users`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                   this.users=response.data;
                   this.users2=response.data;
                }).catch(error => {
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
            },

     filter(){
            let filterval=this.message.filterval;
            if(filterval==='' || filterval===null){
                this.users=this.users2;
            }else{
                let ads =  this.users2.filter(function(product) {
                    return product.fname.toLowerCase().includes(filterval.toLowerCase()) || product.lname.toLowerCase().includes(filterval.toLowerCase()) || product.email.toLowerCase().includes(filterval.toLowerCase())
                });
                this.users=ads;
            }
        },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            filerDate(date){
                return moment(String(date)).format('MM/DD/YYYY HH:mm')
            }

        },
    }

</script>
